import api from "@/utils/axios"

// Fetch all jobs with optional pagination and search filters
// params can include:
// - page: number
// - limit: number
// - search: string (title, location, or type)
// - date_from: string (YYYY-MM-DD)
// - date_to: string (YYYY-MM-DD)
export const getAllJobs = (params = {}) =>
    api.get("/api/jobs", { params })

// Fetch a single job by its ID
export const getJobById = (id) => api.get(`/api/jobs/${id}`)

// Create a new job
// Payload should include: title, department, location, type, posted_at
export const createJob = (payload) => api.post("/api/jobs", payload)

// Update an existing job by ID
// Payload can include any of: title, department, location, type, posted_at
export const updateJob = (id, payload) => api.put(`/api/jobs/${id}`, payload)

// Delete a job by ID
export const deleteJob = (id) => api.delete(`/api/jobs/${id}`)